<template>
  <ShowControl  @revert="revertClick"  :title="title" ref="showControl" :knowledgeType="Global.KnowledgeTypeList.filter(c=>c.name == '住宿管理')[0].value">
    <div style="width: 90%;margin-top: 2%;">
        <div style="text-align: right;margin-bottom: 10px;display: flex;justify-content: flex-end">
          <div>
            <label>酒店选择：</label>
            <el-select :disabled="StayArrangeList.filter(c=>c.isDestined == this.Global.StayState.destined).length > 0 ? true : false"
                          size="medium"
                        v-model="hoteId">
              <el-option v-for="item in HotelList"
                          :key="item.name"
                          :label="item.name"
                          :value="item.id"></el-option>
            </el-select>
            <el-button type="primary" style="margin-left: 10px" v-if="StayArrangeList.filter(c=>c.isDestined == Global.StayState.destined).length == 0"
                        @click="predetermine()">{{StayArrangeList.filter(c=>c.isDestined == Global.StayState.destined).length > 0? "取消":"一键预定"}}</el-button>
          </div>
        </div>
        <el-table :data="StayArrangeList"
                  style="width: 100%;height: 85%;"
                  empty-text="暂无数据"
                  v-loading="loding">
          <el-table-column prop="name"
                          label="姓名"
                          align="center">
          </el-table-column>
          <el-table-column prop="origin"
                          label="来源"
                          align="center">
          </el-table-column>
          <el-table-column prop="createTiem"
                          label="是否预定"
                          align="center">
            <template v-slot="scope">
              <label>{{scope.row.isDestined == Global.StayState.destined ? '已预定' : '未预定'}}</label>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-sizes="[5, 10, 15, 20]"
                      :page-size="pagesize"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="StayArrangeTotal"
                      style="display: flex; justify-content: center;margin-top: 10px;">
        </el-pagination>
    </div>
  </ShowControl>
</template>
  <script>
import { mapState } from "vuex";
import emitter from '../../../unit/bus'
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  props: ["department"],
  data () {
    return {
      loding: false,
      caseID: localStorage.getItem("caseId"),
      flowID: localStorage.getItem("flowID"),
      currentPage: 1,
      pagesize: 10,
      StayArrangeList: [],
      StaySModelList: [],
      HotelList: [],
      StayArrangeTotal: 0,
      StayInput: {
        round: null,
        currentPage: null,
        pagesize: null
      },
      hoteId: null,
      title: '住宿管理'
    };
  },
  components: {ShowControl},
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      ChatShow:(state) => state.user.chatShows,
    }),
  },
  created () {
    this.GetAllStayInfo();
    this.GetHotelList();
    this.GetAllStaySModel();
  },
  mounted() {
    this.$refs.showControl.receiveValue(true);
  },
  methods: {
    revertClick(){
      this.$router.push("/ExhibitionServices")
    },
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.GetAllStayInfo();
    },
    //当前页码
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.GetAllStayInfo();
    },
    GetAllStayInfo () {
      this.loading = true
      this.StayInput.round = this.Round;
      this.StayInput.pagesize = this.pagesize;
      this.StayInput.currentPage = this.currentPage;
      this.$http.post('Stay/GetAllStay', this.StayInput).then((res) => {
        if (res.success) {
          this.StayArrangeList = res.dynamicObj
          this.StayArrangeTotal = res.totalRecord;
          if(this.StayArrangeList.filter(c=>c.isDestined == this.Global.StayState.destined).length > 0){
            this.hoteId = this.StayArrangeList.filter(c=>c.isDestined == this.Global.StayState.destined)[0].hotelID
          }
          this.loading = false
          emitter.emit("StayArrange", res.dynamicObj)
        }
      })
    },
    GetHotelList () {
      this.$http.get('Hotel/GetAllHotel?caseID=' + this.caseID).then((res) => {
        if (res.success) {
          this.HotelList = res.dynamicObj
        }
      })
    },
    GetAllStaySModel () {
      this.$http.get('SModel/GetTypeSModel?round=' + this.Round + "&typename=S_Stay").then((res) => {
        if (res.success) {
          this.StaySModelList = res.dynamicObj
        }
      })
    },
    predetermine () {
      if (this.flowID != this.Global.FlowList.执行) {
        this.$message.error("当前流程阶段不是执行，无法进行操作！");
        return;
      }
      if (this.hoteId == null) {
        this.$message.error('请选择酒店！');
        return;
      }
      var list = []
      var data = this.StayArrangeList.filter(c=>c.isDestined == this.Global.StayState.destined)
      if (data.length > 0) {
        list =  this.StaySModelList
        for(var i= 0; i< list.length;i++){
          list[i].state = this.Global.SModel.Delete;
        }
        this.$http
          .post("SModel/PushStrategy", this.Global.getsmodel(list))
          .then((res) => {
            if (res.success) {
              this.Global.sendmsgmd(
                "会展服务",
                `取消预定了住宿`,
                1
              );
              this.GetAllStayInfo();
              this.API.createTaskBar(this.Round,this.Global.EnumUserStatus.delete,'住宿管理');
            } else {
              this.$message.error(res.message);
              return false;
            }
          });
      }
      else {
        if (this.StaySModelList.length == 0) {
          for(var j = 0; j< this.StayArrangeList.length;j++){
            list.push({
              round: parseInt(this.Round),
              type: "S_Stay",
              uuid: this.StayArrangeList[j].uuid,
              sTTime: this.filter.formatDate(new Date()),
              state: this.Global.SModel.Create,
              hotelId: this.hoteId,
              scheduleId: this.StayArrangeList[j].scheduleId,
              stayId: this.StayArrangeList[j].id
            })
          }

        } else {
          list = this.StaySModelList
          for(var c= 0; c< list.length;c++){
            list[c].sTTime = this.filter.formatDate(new Date());
            list[c].state = this.Global.SModel.Update;
            list[c].hotelId = this.hoteId;
          }
        }
        this.$http
          .post("SModel/PushStrategy", this.Global.getsmodel(list))
          .then((res) => {
            if (res.success) {
              this.Global.sendmsgmd(
                "会展服务",
                `一键预定了住宿`,
                1
              );
              this.GetAllStayInfo();
              this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.住宿安排 });  
              this.API.createTaskBar(this.Round,this.Global.EnumUserStatus.normal,'住宿管理');
            } else {
              this.$message.error(res.message);
              return false;
            }
          });
      }

    },
  },
};
  </script>
  
  <style scoped>
</style>